/*
 * @Desc: 
 * @Author: 刘明魁
 * @Date: 2022-12-28 08:52:25
 * @LastEditors: 刘明魁
 * @LastEditTime: 2023-07-25 09:12:26
 */
/**
  * 首页 接口的统一出口
  */
import axios from '../http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来
import publicData from '../../config'

const index = {
  // 首页
  index (params) {
    return axios.get('/home/index', { params: params })
  },
  uploadImage (params) {
    return axios.post('/common/upload/base64', qs.stringify(params))
  },
  commonShare (params) {
	return axios.get('/home/common/share', { params: params })
  },
  searchHot (params) {
    return axios.get('/home/search/key', { params: params })
  },
  searchData (params) {
    return axios.get('/home/search/data', { params: params })
  },
  // 举报
  chatjubao(params){
	  return axios.post('/home/chat/report', qs.stringify(params))
  },
  reviewApp (params) {
    return axios.get('/home/appversionreview/set', { params: params })
  },
  
}

// 导出接口
export default index
